import React, { createContext, useContext, useState } from 'react';

const FiltersContext = createContext();

const DEFAULT_FILTERS = {
  search: '',
  professions: [],
  tools: [],
  level: 'all',
  sortBy: 'newest',
  page: 1,
  contentType: '',
};

export const useFilters = () => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
};

export const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const updateFilters = (newFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  return (
    <FiltersContext.Provider
      value={{
        filters,
        updateFilters,
        DEFAULT_FILTERS,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
